import config from '../../../config.json';

const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKOFICCE_V2 = config.backofficeV2[env];

import React from 'react';

import { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { fetchUsers } from './../../actions/users/fetch_users';

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      filter: '',
      usersArrived: false,
      error: false,
      users: [],
    };
  }

  render() {
    return (
      <div>
        Página não disponível. <br/><br/>{' '}
        <a href={`${BACKOFICCE_V2}/users`}>Clientes V2</a>
      </div>
    );
  }
}

Users.propTypes = {
  users: PropTypes.array,
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number,
  fetchUsers: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    users: state.users.all,
    totalItems: state.users.totalItems,
    itemsPerPage: state.users.itemsPerPage,
  };
}

export default connect(mapStateToProps, { fetchUsers })(Users);

